import { Box, Button, Container, Hidden, Typography } from '@material-ui/core';
import React from 'react';
import { useStyles } from './not-found.style';
import browserHistory from 'utils/browser-utils';

export const NotFound: React.FC = () => {
    const classes = useStyles();
    return (
        <Container maxWidth="lg" className={classes.root}>
            <Box className={classes.info}>
                <Typography variant="h1" className={classes.headingText}>
                    Vaaay !
                    <img className={classes.textDecoration} src={require('assets/404/lines.svg')} alt="lines" />
                </Typography>
                <Box mt={2}>
                    <Typography variant="body1" color="textSecondary">
                        Təəssüf ki, axtardığınız səhifəni{' '}
                        <Hidden mdDown>
                            <br />
                        </Hidden>
                        tapa bilmədik :(
                    </Typography>
                </Box>
                <Box mt={6}>
                    <Button
                        onClick={() => browserHistory.goBack()}
                        variant="contained"
                        color="primary"
                        className={classes.goBack}
                    >
                        Əvvələ qayıt
                    </Button>
                </Box>
            </Box>
            <Box className={classes.image}>
                <img src={require('assets/404/404.svg')} alt="404" />
            </Box>
        </Container>
    );
};
